import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from 'react'
import { Checkbox, Spin } from 'antd'
import { DownOutlined, UpOutlined } from '@ant-design/icons'
import { useRequest } from '@sisyphe/hooks'
import * as api from 'services/user'
import './index.less'

interface SelectAddressProps {
  onChange?: Function
  value?: string | number
}

export interface SelectAddressRefProps {
  /**刷新 */
  refresh: Function
}

const SelectAddress = forwardRef(
  ({ onChange, value }: SelectAddressProps, ref) => {
    const [expandMore, setExpandMore] = useState(false)
    const [addressList, setAddressList] = useState<Array<SwaggerDTO.地址信息>>(
      []
    )
    const [addressIds, setAddressIds] = useState<Array<string | number>>([])

    /**个人帐号信息-收获地址管理 */
    const {
      run: queryUserAddressUsingPOST,
      data: addList,
      loading,
    } = useRequest(async () => {
      const { data } = await api.queryUserAddressUsingPOST()
      return data
    })

    const addressChange = e => {
      let ids = e.slice(e.length - 1)
      setAddressIds(ids)

      onChange?.(addressList.find(item => item.id === ids?.[0]))
    }

    useEffect(() => {
      const addId = addressIds[0]
      let newList: SwaggerDTO.地址信息[] = []
      let topItem: SwaggerDTO.地址信息 | undefined = undefined

      addList?.forEach(item => {
        if (addId) {
          item.id === addId ? (topItem = item) : newList.push(item)
        } else {
          if (item.defaultAddressTag) {
            topItem = item
            onChange?.(item)
            setAddressIds([item.id])
          } else {
            newList.push(item)
          }
        }
      })

      topItem && newList.unshift(topItem)
      setAddressList(newList)
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addressIds, addList])

    useEffect(() => {
      if (!value) return
      setAddressIds([value])
    }, [value])

    const refresh = () => {
      queryUserAddressUsingPOST()
    }

    useImperativeHandle(ref, (): SelectAddressRefProps => ({ refresh }))

    return (
      <Spin spinning={loading}>
        <div className="s-address">
          <Checkbox.Group
            value={addressIds}
            className="s-address-group"
            onChange={addressChange}
          >
            {addressList?.map((item, index) => (
              <div
                className="s-address-item"
                key={item.id}
                style={{ display: index && !expandMore ? 'none' : '' }}
              >
                <Checkbox value={item.id} />
                <p>
                  {item?.addressee} {item.provinceName}
                  {item.cityName}
                  {item.areaName}
                  {item.address} {item?.linkMobile}
                </p>
                {item?.defaultAddressTag && (
                  <span className="s-a-default">默认地址</span>
                )}
              </div>
            ))}
          </Checkbox.Group>
          <p
            className="more-address"
            onClick={() => setExpandMore(!expandMore)}
          >
            <span>{!expandMore ? '更多地址' : '收起更多'}</span>
            {!expandMore ? (
              <DownOutlined className="more-address-icon" />
            ) : (
              <UpOutlined className="more-address-icon" />
            )}
          </p>
        </div>
      </Spin>
    )
  }
)

export default SelectAddress
